const getCurrentScrollMarkerId = (scrollMarkers) => scrollMarkers[scrollMarkers.length - 1];

export default getCurrentScrollMarkerId;
